<script>
import { setLocale, translations } from '@/modules/i18n';

export default {
  name: 'LanguageSelect',
  data() {
    return {
      translations
    };
  },
  methods: {
    // Compares a locale to the current locale
    isLocale(locale) {
      return this.$store.state.locale === locale;
    },

    // Sets the locale
    setLocale(locale) {
      setLocale(locale);
    }
  }
};
</script>

<template>
  <!-- Select control -->
  <el-select
    :value="$store.state.locale"
    placeholder=""
    @change="setLocale"
  >
    <el-option
      v-for="{ code, name } in translations"
      :key="code"
      :label="name"
      :value="code"
      :selected="isLocale(code)"
    />
  </el-select>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

//
// No styles yet
//
</style>
